export const DISABLE_KEYBOARD_YOUTUBE = 0;
export const ENABLE_KEYBOARD_YOUTUBE = 1;
export const REACT_PLAYER_DEFAULT_VOLUME = 1;
